import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Prefix} from '../../../../../models/prefix.model';
import {Group} from '../../../../../models/group.model';
import {PrefixService} from '../../../../../services/frefix.service';
import {AdminService} from '../../../../../services/admin.service';
import {Response} from '@angular/http';

@Component({
  selector: 'app-edit-standard-prefix',
  templateUrl: './edit-standard-prefix.component.html',
  styleUrls: ['./edit-standard-prefix.component.css']
})
export class EditStandardPrefixComponentHead implements OnInit {
  successInfo = false;
  errorInfo = false;
  errorSix = false;
  errorTwelve = false;
  successEight = false;
  successWarningGroups = false;
  found = false;
  oldPrefix: Prefix;
  newPrefixName: string;
  selectedGroupForPrefix: any[] = [];
  groups: any;
  groupsFromEditedPrefix: any[] = [];

  isLoaded = false;

  constructor(public activeModal: NgbActiveModal,
              private prefixService: PrefixService,
              private adminService: AdminService) {
  }

  ngOnInit() {
    this.isLoaded = false;

    this.adminService.getAllGroups().subscribe(
      (response) => {
        if (response.status === 200) {
          this.groups = response.body;
          this.isLoaded = true;
        }
      },
      () => {
        this.isLoaded = true;
        this.errorInfo = true;
      }
    );
  }

  setGroupForPrefix(prefix) {
    this.oldPrefix = prefix;
    this.newPrefixName = prefix.name;
    this.groupsFromEditedPrefix = prefix.prefixGroups;

    this.setSelectedGroupsFromEditedPrefix();
  }

  setSelectedGroupsFromEditedPrefix() {
    for (const grp of this.groupsFromEditedPrefix) {
      this.selectGroupItem(grp);
    }
  }

  editPrefix() {
    this.successInfo = false;
    this.errorInfo = false;
    this.errorSix = false;
    this.errorTwelve = false;
    this.successEight = false;
    this.successWarningGroups = false;

    if (this.selectedGroupForPrefix.length > 0 && this.newPrefixName.trim().length >= 3) {
      this.oldPrefix.name = this.newPrefixName;
      this.oldPrefix.prefixGroups = this.selectedGroupForPrefix;

      this.prefixService.editPrefixInGroup(this.oldPrefix).subscribe(
        (response: any) => {
          if (response.status === 200 || response.status === 208) {
            this.errorInfo = false;
            this.successInfo = true;
            if ((this.prefixService.getGroupPrefixex().length) > 0) {
              this.prefixService.setSelectedPrefix(this.prefixService.getGroupPrefixex()[0]);
            } else {
              this.prefixService.setSelectedPrefix(null);
            }
          }
        },
        (error) => {
          this.successInfo = false;
          this.errorInfo = true;
        }
      );
    } else {
      this.successWarningGroups = true;
    }
  }

  isSelectedGroup(group) {
    this.found = false;
    if (this.selectedGroupForPrefix.length > 0) {
      for (const grp of this.selectedGroupForPrefix) {
        if (grp.id === group.id) {
          this.found = true;
          break;
        }
      }
    }
    return this.found;
  }

  selectGroupItem(group) {
    if (this.isSelectedGroup(group)) {
      const index = this.selectedGroupForPrefix.findIndex(x => x.id === group.id);
      if (index !== -1) {
        this.selectedGroupForPrefix.splice(index, 1);
        if ((this.prefixService.getGroupPrefixex().length - 1) > 0) {
          this.prefixService.setSelectedPrefix(this.prefixService.getGroupPrefixex()[0]);
        } else {
          this.prefixService.setSelectedPrefix(null);
        }
      }
    } else {
      this.selectedGroupForPrefix.push(group);
    }
  }


}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-standard-head/modal/edit-standard-prefix/edit-standard-prefix.component.ts